// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldCustomerIdNumber_labelContainer__BYjrB"};